module.exports = __webpack_public_path__ + "img/pic_logo.f58a9a0a.png";